import { memo, useEffect, useMemo } from 'react';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

import { HIDE_GOOGLE_ADS_ROUTES } from 'utils/constant';

const propTypes = {
  adSlot: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  isStory: PropTypes.bool,
};

const defaultProps = {
  className: '',
  style: {},
  isStory: false,
};

const GoogleAdBanner = ({ className, style, adSlot, isStory }) => {
  const hostname = window?.location?.hostname || '';
  const {
    publicRuntimeConfig: { isProd },
  } = getConfig();
  const router = useRouter();

  const hideGoogleAds = useMemo(() => {
    return HIDE_GOOGLE_ADS_ROUTES?.some((route) => router?.asPath?.startsWith(route));
  }, [hostname]);

  if (hideGoogleAds || (hostname === 'localhost' && !isStory)) {
    return null;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const pushGoogleAd = () => {
      if (hostname !== 'localhost' && !hideGoogleAds) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    };
    window.addEventListener('load', pushGoogleAd);
    return () => {
      window.removeEventListener('load', pushGoogleAd);
    };
  }, []);

  return (
    <ins
      className={`adsbygoogle ${className || ''}`}
      style={{
        display: 'block',
        ...style,
      }}
      data-ad-client="ca-pub-5822163099292706"
      data-ad-slot={adSlot}
      data-adtest={
        !isProd || hostname.includes('dev.zippia') || hostname.includes('dev2.zippia')
          ? 'on'
          : 'off'
      }
    />
  );
};

GoogleAdBanner.propTypes = propTypes;
GoogleAdBanner.defaultProps = defaultProps;

export default memo(GoogleAdBanner);
